import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'category',
  label: 'Category Section',
  description: 'Dynamic sections for displaying product categories.',
  supportedPages: ['home', 'shop', 'cart', 'checkout', 'order-success', 'categories'],
  variants: [
    {
      id: 'v1',
      label: 'V1 (Slider Layout)',
      fields: [
        { key: 'title', label: 'Section Title', type: 'string' },
        { key: 'subtitle', label: 'Subtitle', type: 'string' },
        { key: 'autoplay', label: 'Enable Autoplay', type: 'boolean', default: false },
        { key: 'autoplayDelay', label: 'Autoplay Delay (ms)', type: 'number', default: 3000 },
      ],
    },
  ],
  commonFields: [
    {
      key: 'cardVariant',
      label: 'Card Style',
      type: 'select',
      options: [{ label: 'Standard Card (V1)', value: 'v1' }],
      default: 'v1',
    },
  ],
}
